var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailServerConfigurationCircleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#276EF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 9h-13A1.5 1.5 0 0 0 7 10.5v9c0 .844.656 1.5 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5v-9c0-.813-.688-1.5-1.5-1.5zm0 1.5v1.281c-.719.594-1.844 1.469-4.219 3.344-.531.406-1.562 1.406-2.281 1.375-.75.031-1.781-.969-2.313-1.375-2.374-1.875-3.5-2.75-4.187-3.344V10.5h13zm-13 9v-5.781c.688.562 1.719 1.375 3.25 2.594.688.53 1.906 1.718 3.25 1.687 1.313.031 2.5-1.156 3.219-1.688A507.967 507.967 0 0 1 21.5 13.72V19.5h-13z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailServerConfigurationCircleIcon);
export default __webpack_public_path__ + "static/media/EmailServerConfigurationCircleIcon.8fef911e.svg";
export { ForwardRef as ReactComponent };